export default __webpack_public_path__ + "static/media/sessions_tg_search.271a7f14.jpg";